import auth from "../../auth/auth";

const Login = () => {
    auth.auth.getSession();
    return(<></>)
}

export default Login;